import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { ILookupService, ILookupPageRequest, ILookupGetRecordByIdRequest, GetAllApplicationUsersRequest } from "@shared/mirage/services/ILookupService";
import { BaseApiService } from "./BaseApiService";
import { IUser } from "@shared/mirage/core/contracts/IUser";

export class LookupService extends BaseApiService implements ILookupService {
    constructor() {
        super("mirage/lookup");
    }

    async pageRequest(request: ILookupPageRequest): Promise<IEntityPageResult<unknown>> {
        const response = await this.httpInstance().post("/pageRequest", request);
        return response.data;
    }
    async getRecordById(request: ILookupGetRecordByIdRequest): Promise<unknown> {
        const response = await this.httpInstance().post("/getRecordById", request);
        return response.data;
    }

    async getAllApplicationUsersPageRequest(req: GetAllApplicationUsersRequest): Promise<IEntityPageResult<IUser>> {
        const response = await this.httpInstance().post("/getAllApplicationUsersPageRequest/", req);
        return response.data;
    }
}
